import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

import { setClassNameInDefns } from '../../common/definitionHelper';
import { makeStyles } from '@material-ui/core';

const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        labelNormal: {
            '& .MuiFormControlLabel-label': {
                fontWeight: 400,
            },
        },
        labelBold: {
            '& .MuiFormControlLabel-label': {
                fontWeight: 600,
            },
        },
    }));
};

const getDefns = params => {
    const { classes, props } = params;

    const { onChange, checked } = props;

    const { labelNormal: labelNormalCls, labelBold: labelBoldCls } = classes;

    const defns = {
        formContol: {
            component: 'fieldset',
        },
        formGroup: {
            'aria-label': 'position',
            row: true,
        },
        label: {
            className: props.bold ? labelBoldCls : labelNormalCls,
            value: props.label,
            control: (
                <Checkbox
                    value={props.label}
                    checked={checked}
                    onChange={e => {
                        onChange(e.target.value);
                    }}
                    color="secondary"
                />
            ),
            label: props.label,
            labelPlacement: 'end',
        },
    };

    // inject classes
    setClassNameInDefns(defns, classes);

    return defns;
};

export default function AfitCheckbox(props) {
    const classes = useStyles(/*{param1, param2}*/)();

    const defns = getDefns({
        classes,
        props,
    });

    return (
        <FormControl {...defns.formContol}>
            <FormGroup {...defns.formGroup}>
                <FormControlLabel {...defns.label} />
            </FormGroup>
        </FormControl>
    );
}
